// extracted by mini-css-extract-plugin
export var fadeIn = "_ip-1";
export var modalContent = "_ip-3";
export var overlay = "_ip-0";
export var popoverContent = "_ip-2";
export var results = "_ip-5";
export var searchInputWrapper = "_ip-4";